import { ElementRef, Injectable } from '@angular/core';
import { MessageThreadElementType } from '@sb-tools/typescript/enums/message-thread-element-type.enum';
import { HelperService } from 'src/sb-tools/typescript/services/helper.service';
import { ComponentMessengerService } from '../component-messenger.service';
import { MessagesOrder } from 'src/sb-tools/typescript/enums/messages-order.enum';
import $ from 'jquery';
import { TicketView } from '../../enums/ticket-view.enum';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { NewLinePipe } from '@sb-tools/typescript/pipes/new-line.pipe';
import { TicketSource } from '@sb-tools/typescript/enums/ticket-source.enum';
import { AssignService } from './assign.service';
import { ThreadElementDTO } from '@sb-tools/typescript/models/dto/thread-element.dto';
import { TicketStatus } from '@sb-tools/typescript/enums/ticket-status.enum';
import { ThreadFilterService } from '../thread-filter.service';
import { Observable } from 'rxjs';
import { DetailedTicketDTO } from '../../../core/models/dto/detailed-ticket.dto';
import { SatisfactionDTO } from '../../../core/models/dto/satisfaction.dto';
import { SurveyDTO } from '../../../core/models/dto/survey.dto';

@Injectable({
    providedIn: 'root',
})
export class ReplyService {
    estimatedReminderMenuHeight = 180;
    estimatedReplyMenuHeight = 230;
    isOnlyFb: boolean;
    newReplyEditor;
    newReplyLastHeight;
    wasReplyScrolledToView: boolean;

    constructor(
        private assignService: AssignService,
        private componentMessengerService: ComponentMessengerService,
        private commonDataService: CommonDataService,
        private newLinePipe: NewLinePipe,
    ) {}

    controlVisibilityOfNewReplyField(replySortBy: MessagesOrder, isChatView = false): void {
        if (replySortBy === MessagesOrder.creationTimeAsc) {
            if (!this.newReplyEditor) {
                this.initializeNewReplyEditor();
            }

            const currentHeight = $(this.newReplyEditor).height();

            if (currentHeight > this.newReplyLastHeight) {
                let container = $('#ticket-details-container-for-scroll');

                if (isChatView) {
                    container = $('#scroll-container');
                    setTimeout(() => {
                        container.animate({ scrollTop: container.prop('scrollHeight') }, 200);
                    }, 200);
                } else {
                    setTimeout(() => {
                        container.animate({ scrollTop: container.prop('scrollHeight') }, 1000);
                    }, 200);
                }
            }

            this.newReplyLastHeight = currentHeight;
        }
    }

    initializeNewReplyEditor(): void {
        try {
            this.newReplyEditor = $('#new-reply .ql-editor')[0];
            this.newReplyLastHeight = $(this.newReplyEditor).height();
        } catch {}
    }

    findReply(messageThread: any[], replyId: number) {
        if (typeof replyId === 'string') {
            replyId = +replyId;
        }

        if (messageThread.length) {
            const reply = messageThread.find((message) => {
                return message.id === replyId && message.type === MessageThreadElementType.reply;
            });

            if (!reply) {
                let subReplies = [];

                messageThread.forEach((message) => {
                    subReplies = subReplies.concat(message.subReplies);
                });

                return this.findReply(subReplies, replyId);
            } else {
                return reply;
            }
        } else {
            return null;
        }
    }

    getIsReplyCanBeEditedStatus(ticket: DetailedTicketDTO, userId: string): boolean {
        return (
            ticket.constraints.isReplyEditingAllowed &&
            ticket.isEditable &&
            ticket.status !== TicketStatus.completed &&
            !(
                (ticket.isAssigned && ticket.assignee.id !== userId) ||
                (this.commonDataService.customerSettings.isTicketAssigningObligatory && !ticket.isAssigned)
            )
        );
    }

    getIsTicketCanBeRepliedStatus(ticket: DetailedTicketDTO, userId: string, isCustomerOnline: boolean): boolean {
        return (
            ticket.constraints.isReplyAddingAllowed &&
            ticket.isEditable &&
            ticket.status !== TicketStatus.completed &&
            !(
                (ticket.isAssigned && ticket.assignee.id !== userId) ||
                (this.commonDataService.customerSettings.isTicketAssigningObligatory && !ticket.isAssigned)
            ) &&
            !(
                ticket.constraints.isSingleReplyFromTeamAllowed &&
                ticket.messageThread.filter((messageThreadElement) => {
                    return (
                        (messageThreadElement as ThreadElementDTO).isByTeam &&
                        !(messageThreadElement as ThreadElementDTO).isDeleted
                    );
                }).length
            ) &&
            !(
                ticket.source === TicketSource.chat &&
                ticket.constraints.isReplyAddingBlockedWhenChatIsEnded &&
                !isCustomerOnline &&
                !this.assignService.getIsNotAssignedToCurrentUserStatus(ticket.isAssigned)
            )
        );
    }

    getReplyMenusDropUp(menuButton: ElementRef): boolean[] {
        const replyMenuBtn = menuButton.nativeElement;
        const replyMenuBtnTopOffset = replyMenuBtn.getBoundingClientRect().top;
        const replyMenuBtnHeight = replyMenuBtn.offsetHeight;

        const replyMenuBtnBottomOffset = window.innerHeight - replyMenuBtnTopOffset - replyMenuBtnHeight;

        const isReplyMenuDropUp = replyMenuBtnBottomOffset < this.estimatedReplyMenuHeight;
        let isReminderMenuDropUp: boolean;

        if (isReplyMenuDropUp) {
            isReminderMenuDropUp = replyMenuBtnBottomOffset + replyMenuBtnHeight < this.estimatedReminderMenuHeight;
        } else {
            isReminderMenuDropUp =
                replyMenuBtnBottomOffset < this.estimatedReplyMenuHeight + this.estimatedReminderMenuHeight;
        }

        return [isReplyMenuDropUp, isReminderMenuDropUp];
    }

    // todo: check and add type
    processAttachments(entity): void {
        entity.contentAttachments = entity.attachments.filter((attachment) => {
            return attachment.isContentPart === true;
        });

        entity.notContentAttachments = entity.attachments.filter((attachment) => {
            return !attachment.isContentPart;
        });
    }

    processNewReply(ticket: DetailedTicketDTO, messageThreadElement: ThreadElementDTO): void {
        if (!messageThreadElement.tags) {
            messageThreadElement.tags = [];
        }

        if (!messageThreadElement.parentReplyId) {
            if (ticket.ticketViewType === TicketView.chat) {
                this.componentMessengerService.addNewReply(structuredClone(messageThreadElement));
            } else {
                if (
                    !ticket.messageThread.find((reply) => {
                        return reply.id === messageThreadElement.id && reply.type === MessageThreadElementType.reply;
                    })
                ) {
                    ticket.messageThread.push(this.processRootReply(structuredClone(messageThreadElement)));
                }
            }
        } else {
            const parentReply = this.findReply(ticket.messageThread, messageThreadElement.parentReplyId);

            if (
                parentReply &&
                !parentReply.subReplies.find((subReply) => {
                    return subReply.id === messageThreadElement.id;
                })
            ) {
                parentReply.subReplies.push(this.processReply(structuredClone(messageThreadElement)));
            }
        }
    }

    processReplies(ticket: DetailedTicketDTO): void {
        ticket.messageThread.forEach((reply) => {
            if (reply.type === MessageThreadElementType.reply) {
                this.processRootReply(reply as ThreadElementDTO);
            } else if (reply.type === MessageThreadElementType.survey) {
                (reply as ThreadElementDTO).subReplies = [];
            }
        });
    }

    processRootReply(reply: ThreadElementDTO) {
        this.processReply(reply);

        reply.subReplies.forEach((comment) => {
            this.processRootReply(comment);
        });

        return reply;
    }

    processReply(reply: ThreadElementDTO) {
        reply.editingReply = reply.isDraft;

        if (!reply.message.html) {
            reply.message.html = HelperService.escapeHtml(reply.message.text);
            reply.message.html = this.newLinePipe.transform(reply.message.html);
        }

        reply.message.text = HelperService.parseFromFbSmileys(reply.message.text, this.isOnlyFb);
        reply.message.html = HelperService.parseFromFbSmileys(reply.message.html, this.isOnlyFb);

        this.processAttachments(reply);

        return reply;
    }

    scrollToViewReply(replyId: number, ticket: DetailedTicketDTO): void {
        this.findReplyElement(replyId, ticket).subscribe((reply) => {
            if (reply) {
                const scrolledElement = $(reply);
                scrolledElement.removeClass('highlighted-reply');
                setTimeout(() => {
                    scrolledElement.addClass('highlighted-reply');
                });

                if (ticket.ticketViewType === TicketView.chat) {
                    const container = $('#scroll-container');
                    container.animate({
                        scrollTop: scrolledElement.offset().top - container.offset().top + container.scrollTop() - 100,
                    });
                } else {
                    const parent = $('#ticket-details-container-for-scroll');

                    const headerWithFilters = ticket.ticketViewType === TicketView.socialMedia;

                    let parentScrollTop = parent.scrollTop() + scrolledElement.offset().top - 100;

                    const fullHeaderHeight = $('.ticket-header')[0].offsetHeight;
                    const stickyHeaderHeight = $('#ticket-short-header')[0].offsetHeight;
                    const headerWithoutSticky = fullHeaderHeight - stickyHeaderHeight - 3;

                    const willBeStickyHeader = parentScrollTop > $('#ticket-short-header')[0].offsetTop;
                    const isStickyHeader = parent.scrollTop() > $('#ticket-short-header')[0].offsetTop;

                    const stickyHeaderHeightWithFilters = stickyHeaderHeight - 17;
                    const stickyHeaderHeightWithoutFilters = stickyHeaderHeight + 11;

                    if (isStickyHeader) {
                        parentScrollTop = parentScrollTop - stickyHeaderHeight;
                    } else if (willBeStickyHeader) {
                        parentScrollTop =
                            parentScrollTop -
                            (fullHeaderHeight - headerWithoutSticky) -
                            (headerWithFilters ? stickyHeaderHeightWithFilters : stickyHeaderHeightWithoutFilters);
                    }

                    parent.animate(
                        {
                            scrollTop: parentScrollTop,
                        },
                        'slow',
                    );
                }
            }
        });
    }

    updateDataForDeletedReply(reply: ThreadElementDTO): void {
        reply.contentAttachments = [];
        reply.notContentAttachments = [];

        reply.subReplies.forEach((subReply) => {
            this.updateDataForDeletedReply(subReply);
        });
    }

    updateThreadLastUpdateTime(
        messageThread: (ThreadElementDTO | SatisfactionDTO | SurveyDTO)[],
        time: Date,
        replyIds: number[],
    ): void {
        if (replyIds.length) {
            const rootReply = this.findReply(messageThread, replyIds[0]);

            if (rootReply) {
                rootReply.threadLastUpdateTime = time;

                let replies = rootReply.subReplies;

                for (let i = 1; i < replyIds.length; ++i) {
                    const reply = this.findReply(replies, replyIds[i]);
                    if (reply) {
                        reply.threadLastUpdateTime = time;
                        replies = reply.subReplies;
                    }
                }
            }
        }
    }

    // todo update if we will support more than 2 levels again
    updateReplyData(
        ticket: DetailedTicketDTO,
        newReply: ThreadElementDTO,
        socialMediaSourceId: string | number,
        isDeleting = false,
    ): void {
        const reply = this.findReply(ticket.messageThread, newReply.id);

        if (reply) {
            const processedReply = this.processRootReply(newReply);
            reply.author.blockingInfo = processedReply.author.blockingInfo;
            reply.message = processedReply.message;
            reply.permalink = processedReply.permalink;
            reply.attachments = processedReply.attachments;
            reply.socialMediaSourceId = socialMediaSourceId;
            reply.isAutoHidden = processedReply.isAutoHidden;
            reply.isByTeam = processedReply.isByTeam;
            reply.isDeleted = processedReply.isDeleted;
            reply.isDraft = processedReply.isDraft;
            reply.isEdited = processedReply.isEdited;
            reply.isHidden = processedReply.isHidden;
            reply.isViewed = processedReply.isViewed;
            reply.handledBy = processedReply.handledBy;
            reply.containsBadWords = processedReply.containsBadWords;

            this.processAttachments(reply);
            newReply.subReplies.forEach((subReply) => {
                this.updateReplyData(ticket, subReply, socialMediaSourceId, isDeleting);
            });

            if (isDeleting) {
                reply.contentAttachments = [];
                reply.notContentAttachments = [];
                reply.subReplies.forEach((subReply) => {
                    this.updateDataForDeletedReply(subReply);
                });
            }
        }
    }

    private showAllSubRepliesOfParents(parentReplyIds: number[], ticket: DetailedTicketDTO): void {
        parentReplyIds.forEach((replyId) => {
            const reply = this.findReply(ticket.messageThread, replyId);
            if (reply) {
                reply.areCommentsShown = true;
            }
        });
    }

    private findReplyElement(replyId: number, ticket: DetailedTicketDTO): Observable<Element> {
        return new Observable((observer) => {
            const reply = this.findReply(ticket.messageThread, replyId);
            if (reply) {
                this.wasReplyScrolledToView = false;

                setTimeout(() => {
                    const replyToView = document.getElementById(`reply-id-${replyId}`);
                    if (replyToView) {
                        observer.next(replyToView);
                    } else {
                        if (ticket.ticketViewType === TicketView.chat) {
                            this.componentMessengerService.showAllChatReplies();
                        } else {
                            ThreadFilterService.showAllReplies(ticket.messageThread.length);
                            this.showAllSubRepliesOfParents(reply.parentReplyIds, ticket);
                            ThreadFilterService.refreshUpdateStamp();
                        }

                        setTimeout(() => {
                            const replyToViewNew = document.getElementById(`reply-id-${replyId}`);

                            if (replyToViewNew) {
                                observer.next(replyToViewNew);
                            } else {
                                observer.next(null);
                            }
                        }, 100);
                    }
                }, 100);
            } else {
                observer.next(null);
            }
        });
    }
}
